module.exports = __WEBPACK_EXTERNAL_MODULE_56__;


//////////////////
// WEBPACK FOOTER
// external "@ngx-translate/core"
// module id = 56
// module chunks = 0